<template>
    <div>

        <div class="spo-card rounded p-2 bg-orange-lighten-5">

            <div class="text-h6 text-darkblue font-weight-bold">Report de votre inscription</div>
            <v-chip variant="flat"
                :color="statusInscription == 'Inscription annulée' ? 'red-darken-4' : 'green-darken-4'">Etat
                actuel
                de votre inscription : {{ statusInscription
                }}</v-chip>
            <div class="mt-2">
                <p>Madame, Monsieur,</p>
                <p>

                    Suite à l'annulation de cette édition, l'organisation vous propose de conserver votre inscription
                    pour la prochaine édition qui aura lieu le 13 Septembre 2026 ou de faire une demande de
                    remboursement.
                </p>
                <p>
                    Nous vous remercions de bien vouloir nous faire parvenir votre décision avant le 22 Mai 2026.
                </p>
            </div>
            <SportipsButton
                v-if="statusInscription == 'Inscription annulée' || statusInscription == 'Choix non effectué'"
                action-button icon="mdi-check" chevron class="my-2" @onClick="keepInscription">Je souhaite conserver mon
                inscription</SportipsButton>
            <SportipsButton
                v-if="statusInscription == 'Inscription conservée' || statusInscription == 'Choix non effectué'"
                action-button icon="mdi-cancel" chevron class="my-2" @onClick="cancelInscription">Je souhaite être
                remboursé</SportipsButton>




            <div>L'organisateur vous remercie de votre compréhension.</div>
        </div>
    </div>
</template>

<script>
import UserService from '@/services/user.service';
export default {

    props: ["inscription"],
    computed: {
        statusInscription() {

            if (!this.inscription || !this.inscription.champs) {
                return 'Choix non effectué';
            }
            const champ_keep_inscription = this.inscription.champs['superbesse_triath26_keep_inscription'];

            if (champ_keep_inscription && champ_keep_inscription == '0') {
                return 'Inscription annulée';
            }
            else if (champ_keep_inscription && champ_keep_inscription == '1') {
                return 'Inscription conservée';
            }
            else {
                return 'Choix non effectué';
            }

        }
    },
    methods: {
        async cancelInscription() {

            await UserService.updateInscriptionChamp(this.inscription.id, 'superbesse_triath26_keep_inscription', '0');
            window.location.reload();
        },
        async keepInscription() {

            await UserService.updateInscriptionChamp(this.inscription.id, 'superbesse_triath26_keep_inscription', '1');
            window.location.reload();
        }
    }
}
</script>

<style lang="scss" scoped></style>